import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faPlus, faSave, faSearch, faFilePdf, faPrint, faBroom } from '@fortawesome/free-solid-svg-icons';
import './DelNote.css'
import { Tooltip } from 'react-tooltip';
import GoCast from '../../Images/GoCast.png';
import I70 from '../../Reports/I-70_Delivery.pdf'

const DelNote = () => {
    // Option Panel visibility
    const [panel1Visible, setPanel1Visible] = useState(true);
    // Advanced Panel visibility
    const [panel2Visible, setPanel2Visible] = useState(true);
    // Toggle Option Panel visibility
    const togglePanel1Visibility = () => {
        setPanel1Visible(!panel1Visible);
    }
    // Toggle Advanced Panel visibility
    const togglePanel2Visibility = () => {
        setPanel2Visible(!panel2Visible);
    }

    const [invoiceInput, setInvoiceInput] = useState('');


    return (
        <div className='card panelcard'>
            <div className='OptionForm'>
                <div className="card-header">
                    {/* <h2 className='panel-title-report'>Delivery Note</h2> */}
                    <div className='ctrl-btns-report'>
                        <button className="btn" id='preview' onClick={() => {
                            if (invoiceInput === 'I-70') {
                                window.open(I70, '_blank');
                            }
                        }}>
                            <FontAwesomeIcon icon={faFilePdf} />
                        </button>
                        <Tooltip
                            anchorSelect="#preview"
                            content="Preview"
                            place='bottom'
                        />
                        <button className="btn" id='Print'>
                            <FontAwesomeIcon icon={faPrint} />
                        </button>
                        <Tooltip
                            anchorSelect="#Print"
                            content="Print"
                            place='bottom'
                        />
                        <button className="btn" id='Clear'>
                            {/* <FontAwesomeIcon icon={faBroom} /> */}
                            <svg className='myBroom' width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="white" stroke-width="0.744">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M22.4524 1.92267C22.7452 2.21557 22.7452 2.69044 22.4524 2.98333L16.1393 9.29634C15.9927 9.11579 15.8353 8.94105 15.6673 8.77297C15.4768 8.58252 15.2778 8.40582 15.0715 8.24289L21.3917 1.92267C21.6846 1.62978 22.1595 1.62978 22.4524 1.92267Z" fill="#000"></path>
                                    <path d="M15.0277 9.34728C12.7822 7.10177 9.14153 7.10177 6.89601 9.34728L6.65198 9.59131L14.7837 17.723L15.0277 17.479C17.2733 15.2335 17.2733 11.5928 15.0277 9.34728Z" fill="#000"></path>
                                    <path d="M1.8838 12.9659L5.49664 10.5573L13.8177 18.8784L11.4091 22.4912C11.2845 22.6782 11.0826 22.7994 10.859 22.8215C10.6354 22.8437 10.4137 22.7644 10.2548 22.6055L1.76949 14.1202C1.61061 13.9613 1.53133 13.7396 1.55347 13.516C1.57561 13.2924 1.69684 13.0905 1.8838 12.9659Z" fill="#000"></path>
                                </g>
                            </svg>
                        </button>
                        <Tooltip
                            anchorSelect="#Clear"
                            content="Clear Form"
                            place='bottom'
                        />
                    </div>
                </div>
                {/* Panel 1  */}
                <div className="card-body">
                    <div className="card-header">
                        <button type="button" className="toggle-table-icon" onClick={togglePanel1Visibility}>
                            <FontAwesomeIcon icon={panel1Visible ? faArrowDown : faArrowUp} />
                        </button>
                        <h5 className='card-body-title'>
                            Options
                        </h5>
                    </div>
                    {panel1Visible && (
                        <div class="table-responsive-md">
                            <div className='TruckForm'>
                                <form>
                                    <div class="row">
                                        <div class="col-3 leftCol">
                                            <input type='text' placeholder=' Invoice' className='Elementidinput-report' value={invoiceInput} onChange={(e) => setInvoiceInput(e.target.value)} />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
                {/* Panel 2 */}
                <div className="card-body">
                    <div className="card-header">
                        <button type="button" className="toggle-table-icon" onClick={togglePanel2Visibility}>
                            <FontAwesomeIcon icon={panel2Visible ? faArrowDown : faArrowUp} />
                        </button>
                        <h5 className='card-body-title'>
                            Advanced
                        </h5>
                    </div>
                    {panel2Visible && (
                        <div class="table-responsive-md">
                            <div className='OptionForm'>
                                <form>
                                    <div class="row">
                                        <div class="col-3 leftCol">
                                            <select id="outputFormat" class="Elementidinput-report" value="Output Format">
                                                <option selected>Output Format</option>
                                                <option selected>PDF</option>
                                                <option>Excel</option>
                                            </select>
                                            <select id="schedule" class="Elementidinput-report" value="Schedule">
                                                <option selected>Schedule</option>
                                                <option>Now</option>
                                            </select>
                                        </div>
                                        <div class="col-3 midCol">
                                            <input type='text' placeholder=' User Description' className='Elementidinput-report' />
                                            <select id="reportStyle" class="Elementidinput-report" value="Report Style">
                                                <option selected>Report Style</option>
                                                <option>Excel</option>
                                            </select>
                                            <select id="archievePeriod" class="Elementidinput-report" value="Archieve Period">
                                                <option selected>Archieve Period</option>
                                                <option>Now</option>
                                            </select>
                                        </div>
                                        <div class="col-3 rightCol-rep">
                                            <div className='chkbox-container-rep'>
                                                <input class="form-check-input " type="checkbox" id="routing" />
                                                <label class="form-check-label " for="routing">
                                                    Routing
                                                </label>
                                            </div>
                                            <div className='chkbox-container-rep'>
                                                <input class="form-check-input " type="checkbox" id="recurring" />
                                                <label class="form-check-label " for="recurring">
                                                    Recurring
                                                </label>
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

    );
};

export default DelNote;